<template>
  <div class="d-flex flex-column ga-2">
    <div
      v-for="item in items"
      :key="`${item.id}-${item.scannedAt || item.product.sku}`"
      class="d-flex justify-space-between align-center pa-2 bg-grey-100 rounded"
    >
      <div class="flex-grow-1">
        <h6 class="font-weight-bold">
          <span class="text-caption text-grey-600">{{ item.product.sku }}</span>
          - {{ item.product.name }}
        </h6>

        <div class="mt-1">
          <div class="d-flex flex-wrap ga-1">
            <v-chip
              v-if="item.lote"
              size="small"
              color="blue-grey"
              variant="outlined"
            >
              Lote: {{ item.lote }}
            </v-chip>

            <v-chip
              v-if="item.series_arr && item.series_arr.length > 0"
              size="small"
              color="blue-grey"
              variant="outlined"
            >
              Serie: {{ item.series_arr[0].serie }}
            </v-chip>

            <v-chip
              v-if="item.expiration_date"
              size="small"
              color="blue-grey"
              variant="outlined"
            >
              Vto: {{ formatDate(item.expiration_date) }}
            </v-chip>

            <v-chip
              v-if="item.quality"
              size="small"
              color="blue-grey"
              variant="outlined"
            >
              Calidad: {{ item.quality.name }}
            </v-chip>

            <v-chip
              v-if="item.storage_units_amount && item.storage_units_amount > 0"
              size="small"
              color="blue-grey"
              variant="outlined"
            >
              Valor de almacenamiento: {{ item.storage_units_amount }}
            </v-chip>

            <v-chip
              v-if="item.descriptivo_1"
              size="small"
              color="blue-grey"
              variant="outlined"
            >
              {{ getAliasName("descriptivo_1") }}: {{ item.descriptivo_1 }}
            </v-chip>

            <v-chip
              v-if="item.descriptivo_2"
              size="small"
              color="blue-grey"
              variant="outlined"
            >
              {{ getAliasName("descriptivo_2") }}: {{ item.descriptivo_2 }}
            </v-chip>

            <v-chip
              v-if="item.descriptivo_3"
              size="small"
              color="blue-grey"
              variant="outlined"
            >
              {{ getAliasName("descriptivo_3") }}: {{ item.descriptivo_3 }}
            </v-chip>
          </div>
        </div>
      </div>

      <div class="d-flex align-center ga-2">
        <v-chip variant="tonal" color="black">
          {{ item.amount }}
        </v-chip>

        <v-tooltip text="Eliminar ítem" location="bottom">
          <template #activator="{ props }">
            <v-icon
              v-if="showRemoveButton"
              v-bind="props"
              color="white"
              class="bg-red rounded cursor-pointer"
              @click="$emit('remove-item', packageId, item)"
            >
              mdi-minus
            </v-icon>
          </template>
        </v-tooltip>
      </div>
    </div>
  </div>
</template>

<script>
import { formatUtils } from "@/libs/utils/formatUtils";
import AliasMixin from "@/mixins/AliasMixin.vue";

export default {
  name: "PackageItemList",
  mixins: [AliasMixin],
  emits: ["remove-item"],
  props: {
    items: {
      type: Array,
      required: true,
      default: () => [],
    },
    packageId: {
      type: Number,
      default: null,
    },
    showRemoveButton: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    formatDate(dateString) {
      if (!dateString) return "";
      return formatUtils.formatDate(dateString);
    },
  },
};
</script>

<style scoped>
.ga-1 {
  gap: 4px;
}

.ga-2 {
  gap: 8px;
}

.cursor-pointer {
  cursor: pointer;
}

.bg-red {
  background-color: #ef4444 !important;
}
</style>
